import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-un-auth content" }
const _hoisted_2 = { class: "main-un-auth__features" }

import { useAuthModalStore } from '@/store'
import Button from '@/components/ui/Button'
import IconedText from '@/components/ui/IconedText'
import Title from '@/components/ui/Title'

// Methods

export default /*#__PURE__*/_defineComponent({
  __name: 'UnAuth',
  setup(__props) {

// Store
const modalStore = useAuthModalStore()

// Components
function doReg(): void {
  modalStore.openReg()
}

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Title), {
      type: "h1",
      theme: "huge",
      class: "main-un-auth__title"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('main.unAuth.title')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('main.unAuth.desc')), 1),
    _createVNode(_unref(Button), {
      theme: "huge",
      onClick: doReg
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('main.unAuth.register')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IconedText), null, {
        icon: _withCtx(() => [
          _createVNode(_component_draw_svg, {
            name: "check",
            width: "9",
            height: "7"
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.$t('main.unAuth.features.events')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IconedText), null, {
        icon: _withCtx(() => [
          _createVNode(_component_draw_svg, {
            name: "check",
            width: "9",
            height: "7"
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.$t('main.unAuth.features.fastPayments')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})